"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeBuilder = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _stencilTheme = _interopRequireDefault(require("../theme/stencilTheme"));
var _constants = require("./constants");
/**
 * Type for theme token keys that can be used in the theme builder
 */

/**
 * Type for theme token values that can be used in the theme builder
 * Values can be either:
 * - References to other tokens (with autocompletion)
 * - Direct CSS values (strings or numbers)
 */

/**
 * Type for theme overrides object
 */

/**
 * ThemeBuilder class provides a fluent API for customizing themes
 */
class ThemeBuilder {
  /**
   * Creates a new ThemeBuilder instance
   * @param baseTheme - The base theme to extend (defaults to the Stencil theme)
   */
  constructor() {
    let baseTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _stencilTheme.default;
    (0, _defineProperty2.default)(this, "theme", void 0);
    (0, _defineProperty2.default)(this, "lightThemeOverrides", {});
    (0, _defineProperty2.default)(this, "darkThemeOverrides", {});
    this.theme = baseTheme;
  }

  /**
   * Set overrides for the light theme
   * @param overrides - Object containing token key-value pairs to override
   * @returns The ThemeBuilder instance for chaining
   */
  setLightTheme(overrides) {
    this.lightThemeOverrides = {
      ...this.lightThemeOverrides,
      ...overrides
    };
    return this;
  }

  /**
   * Set overrides for the dark theme
   * @param overrides - Object containing token key-value pairs to override
   * @returns The ThemeBuilder instance for chaining
   */
  setDarkTheme(overrides) {
    this.darkThemeOverrides = {
      ...this.darkThemeOverrides,
      ...overrides
    };
    return this;
  }

  /**
   * Checks if a value is a token reference
   * Ex: 'color.red.10', 'text.body.lg.lineHeight.breakpoint-xl'
   * @param value - The value to check
   * @returns True if the value is a token reference
   */
  isTokenReference(value) {
    return _constants.TOKEN_REGEX.test(value);
  }

  /**
   * Processes a token value, preserving references to other tokens
   * @param value - The token value to process
   * @returns The processed token value
   */
  processTokenValue(value) {
    if (typeof value === 'string' && this.isTokenReference(value)) {
      return "var(--".concat(_constants.STENCIL_TOKENS_NAMESPACE, "-").concat(value.replaceAll('.', '-'), ")");
    }
    return value;
  }

  /**
   * Applies overrides to a theme section
   * @param themeSection - The theme section to apply overrides to
   * @param overrides - The overrides to apply
   * @returns The updated theme section
   */
  applyOverrides(themeSection, overrides) {
    const result = themeSection;
    for (const [key, value] of Object.entries(overrides)) {
      const cssVarName = "--".concat(_constants.STENCIL_TOKENS_NAMESPACE, "-").concat(key.replaceAll('.', '-'));
      const processedValue = this.processTokenValue(value);
      result[cssVarName] = processedValue;
    }
    return result;
  }

  /**
   * Builds the final theme with all applied overrides
   * @returns The customized theme
   */
  build() {
    const result = (0, _deepmerge.default)({}, this.theme);
    if (Object.keys(this.lightThemeOverrides).length > 0) {
      result[':root'] = this.applyOverrides(result[':root'], this.lightThemeOverrides);
    }
    if (Object.keys(this.darkThemeOverrides).length > 0) {
      result[_constants.PREFERS_COLOR_SCHEME_DARK_SELECTOR] = this.applyOverrides(result[_constants.PREFERS_COLOR_SCHEME_DARK_SELECTOR], this.darkThemeOverrides);
    }
    return result;
  }
}

/**
 * Creates a new ThemeBuilder instance
 * @param baseTheme - The base theme to extend (defaults to the default theme)
 * @returns A new ThemeBuilder instance
 */
const themeBuilder = function () {
  let baseTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _stencilTheme.default;
  return new ThemeBuilder(baseTheme);
};
exports.themeBuilder = themeBuilder;
var _default = exports.default = themeBuilder;